import React from "react";
import { FormattedMessage } from "react-intl";
import styles from "../../FilePreviewModal.module.scss";
import { EThemeType } from "redux/reducers";
import EpubReader from "./EpubReader";

interface BrowserPreviewProps {
    fileType: string;
    url: string;
    theme: EThemeType | undefined;
}

const BrowserPreview: React.FC<BrowserPreviewProps> = ({ fileType, url }) => {
    // Check if it's an Office file
    const iSPPTFile = ['pptx', 'ppt'].includes(fileType.toLowerCase());
    const iXLSFile = ['xlsx', 'xls',].includes(fileType.toLowerCase());
    const isEpub = fileType.toLowerCase() === 'epub';

    const getViewerUrl = () => {
        if (iSPPTFile) {
            return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
        }
        else if (iXLSFile) {
            return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`;
        }
        // For other file types, use the direct URL
        return url;
    };

    return (
        <div className={styles.browserPreview} style={{ width: '100%', height: '100%' }}>
            {iSPPTFile || iXLSFile ? (
                // Embedded iframe for Office files with full width and height
                <iframe
                    src={getViewerUrl()}
                    style={{
                        width: '100%',
                        height: '100vh',
                        maxHeight: 'calc(100vh - 80px)',
                        border: 'none',
                        overflow: 'hidden'
                    }}
                    frameBorder="0"
                    title="Office file preview"
                    allowFullScreen={true}
                />
            ) : isEpub ? (
                <EpubReader url={url} />
            ) : (
                <div className={styles.fileInfo}>
                    <button
                        onClick={() => window.open(url, '_blank')}
                        className={styles.openButton}
                    >
                        <FormattedMessage
                            id="file.open.browser"
                            defaultMessage="Open in browser"
                        />
                    </button>
                </div>
            )}
        </div>
    );
};

export default BrowserPreview;